import { AssetPack, Component } from "./assets";
import { PackSource } from "./pack_sources";

export const htmlColors: { [colorName: string]: string; } = {
    "aliceblue": "#f0f8ff", "antiquewhite": "#faebd7", "aqua": "#00ffff", "aquamarine": "#7fffd4", "azure": "#f0ffff",
    "beige": "#f5f5dc", "bisque": "#ffe4c4", "black": "#000000", "blanchedalmond": "#ffebcd", "blue": "#0000ff", "blueviolet": "#8a2be2", "brown": "#a52a2a", "burlywood": "#deb887",
    "cadetblue": "#5f9ea0", "chartreuse": "#7fff00", "chocolate": "#d2691e", "coral": "#ff7f50", "cornflowerblue": "#6495ed", "cornsilk": "#fff8dc", "crimson": "#dc143c", "cyan": "#00ffff",
    "darkblue": "#00008b", "darkcyan": "#008b8b", "darkgoldenrod": "#b8860b", "darkgray": "#a9a9a9", "darkgreen": "#006400", "darkkhaki": "#bdb76b", "darkmagenta": "#8b008b", "darkolivegreen": "#556b2f",
    "darkorange": "#ff8c00", "darkorchid": "#9932cc", "darkred": "#8b0000", "darksalmon": "#e9967a", "darkseagreen": "#8fbc8f", "darkslateblue": "#483d8b", "darkslategray": "#2f4f4f", "darkturquoise": "#00ced1",
    "darkviolet": "#9400d3", "deeppink": "#ff1493", "deepskyblue": "#00bfff", "dimgray": "#696969", "dodgerblue": "#1e90ff",
    "firebrick": "#b22222", "floralwhite": "#fffaf0", "forestgreen": "#228b22", "fuchsia": "#ff00ff",
    "gainsboro": "#dcdcdc", "ghostwhite": "#f8f8ff", "gold": "#ffd700", "goldenrod": "#daa520", "gray": "#808080", "green": "#008000", "greenyellow": "#adff2f",
    "honeydew": "#f0fff0", "hotpink": "#ff69b4",
    "indianred ": "#cd5c5c", "indigo": "#4b0082", "ivory": "#fffff0", "khaki": "#f0e68c",
    "lavender": "#e6e6fa", "lavenderblush": "#fff0f5", "lawngreen": "#7cfc00", "lemonchiffon": "#fffacd", "lightblue": "#add8e6", "lightcoral": "#f08080", "lightcyan": "#e0ffff", "lightgoldenrodyellow": "#fafad2",
    "lightgrey": "#d3d3d3", "lightgreen": "#90ee90", "lightpink": "#ffb6c1", "lightsalmon": "#ffa07a", "lightseagreen": "#20b2aa", "lightskyblue": "#87cefa", "lightslategray": "#778899", "lightsteelblue": "#b0c4de",
    "lightyellow": "#ffffe0", "lime": "#00ff00", "limegreen": "#32cd32", "linen": "#faf0e6",
    "magenta": "#ff00ff", "maroon": "#800000", "mediumaquamarine": "#66cdaa", "mediumblue": "#0000cd", "mediumorchid": "#ba55d3", "mediumpurple": "#9370d8", "mediumseagreen": "#3cb371", "mediumslateblue": "#7b68ee",
    "mediumspringgreen": "#00fa9a", "mediumturquoise": "#48d1cc", "mediumvioletred": "#c71585", "midnightblue": "#191970", "mintcream": "#f5fffa", "mistyrose": "#ffe4e1", "moccasin": "#ffe4b5",
    "navajowhite": "#ffdead", "navy": "#000080",
    "oldlace": "#fdf5e6", "olive": "#808000", "olivedrab": "#6b8e23", "orange": "#ffa500", "orangered": "#ff4500", "orchid": "#da70d6",
    "palegoldenrod": "#eee8aa", "palegreen": "#98fb98", "paleturquoise": "#afeeee", "palevioletred": "#d87093", "papayawhip": "#ffefd5", "peachpuff": "#ffdab9", "peru": "#cd853f", "pink": "#ffc0cb", "plum": "#dda0dd", "powderblue": "#b0e0e6", "purple": "#800080",
    "rebeccapurple": "#663399", "red": "#ff0000", "rosybrown": "#bc8f8f", "royalblue": "#4169e1",
    "saddlebrown": "#8b4513", "salmon": "#fa8072", "sandybrown": "#f4a460", "seagreen": "#2e8b57", "seashell": "#fff5ee", "sienna": "#a0522d", "silver": "#c0c0c0", "skyblue": "#87ceeb", "slateblue": "#6a5acd", "slategray": "#708090", "snow": "#fffafa", "springgreen": "#00ff7f", "steelblue": "#4682b4",
    "tan": "#d2b48c", "teal": "#008080", "thistle": "#d8bfd8", "tomato": "#ff6347", "turquoise": "#40e0d0",
    "violet": "#ee82ee",
    "wheat": "#f5deb3", "white": "#ffffff", "whitesmoke": "#f5f5f5",
    "yellow": "#ffff00", "yellowgreen": "#9acd32"
};

const testerCanvas = document.createElement("canvas");
testerCanvas.height = 1;
testerCanvas.width = 1;
const testerCtx = testerCanvas.getContext("2d");
export function standardizeColor(str: string) {
    if (str.startsWith('#')) return str;
    testerCtx.fillStyle = str;
    return <string>testerCtx.fillStyle;
}


type ImageAsset = string | { url: string };

export function drawColor(ctx: CanvasRenderingContext2D, img: HTMLImageElement, color: string, offset?: { x: number, y: number }, size?: { w: number, h: number }) {

    const tempCanvas = <HTMLCanvasElement>document.getElementById('dbg');

    tempCanvas.width = img.width;
    tempCanvas.height = img.height;
    const c = tempCanvas.getContext('2d');

    fill(c, color);

    c.globalCompositeOperation = "multiply";
    c.drawImage(img, 0, 0, c.canvas.width, c.canvas.height);
    c.globalCompositeOperation = "destination-in";
    c.drawImage(img, 0, 0, c.canvas.width, c.canvas.height);
    ctx.drawImage(tempCanvas, offset?.x ?? 0, offset?.y ?? 0, size?.w ?? ctx.canvas.width, size?.h ?? ctx.canvas.height);
}

export function draw(ctx: CanvasRenderingContext2D, img: HTMLImageElement, offset?: { x: number, y: number }, size?: { w: number, h: number }) {
    ctx.drawImage(img, offset?.x ?? 0, offset?.y ?? 0, size?.w ?? ctx.canvas.width, size?.h ?? ctx.canvas.height);
}

export function fill(ctx: CanvasRenderingContext2D, color: string) {
    ctx.globalCompositeOperation = "source-over";
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}

export function clear(ctx: CanvasRenderingContext2D) {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}

function prepareImages(componentsByLayer: { [layer: string]: Component[] }, packSource: PackSource, pack: AssetPack) {
    const urls = [];
    for (const layerName in componentsByLayer) {
        const l = componentsByLayer[layerName];
        for (const comp of l) {
            if (comp.url in pack.optimizedImages && "trim-full" in pack.optimizedImages[comp.url]) {
                urls.push(pack.optimizedImages[comp.url]["trim-full"].url);
            } else {
                urls.push(comp.url);
            }
        }
    }
    return packSource.preloadImages(urls);
}

export async function render(canvas: HTMLCanvasElement, pack: AssetPack, packSource: PackSource, componentsByLayer: { [layer: string]: Component[] }, colorValues: { [color: string]: string }) {
    const ctx = canvas.getContext('2d');

    for (const colorId in colorValues) {
        colorValues[colorId] = standardizeColor(colorValues[colorId]);
    }
    clear(ctx);

    await prepareImages(componentsByLayer, packSource, pack);

    for (const layerName in componentsByLayer) {
        const l = componentsByLayer[layerName];
        for (const comp of l) {
            let url = comp.url;
            let offset = { x: 0, y: 0 };
            let size = { w: canvas.width, h: canvas.height };
            if (comp.url in pack.optimizedImages && "trim-full" in pack.optimizedImages[comp.url]) {
                const variant = pack.optimizedImages[comp.url]["trim-full"];
                url = variant.url;
                offset = variant.offset;
                size = variant.size;
            }

            if ("color" in comp && comp.color != "none"
                && colorValues[comp.color] != "#ffffff") {
                drawColor(ctx, packSource.getImage(url), colorValues[comp.color], offset, size);
            }
            else {
                draw(ctx, packSource.getImage(url), offset, size);
            }
        }
    }
}